module.exports = __webpack_public_path__ + "img/b_02.a48a551e.png";